/**
 * @owner @Appboy/whats-app
 * WhatsApp Carousel Card Schema
 *
 * Shared schema for carousel card liquid content in template messages.
 * Note: Carousel cards cannot be nested (backend validation rejects nested cards).
 */

import { z } from "zod";
import { common } from "../common";
import { whatsAppMediaTypeSchema } from "./whatsAppMediaTypeSchema";

// Same between GET and POST
export const whatsAppCarouselCardSchema = z.object({
  header_liquid_variables: z.array(z.string()).optional(),
  body_liquid_variables: z.array(z.string().nullable()).optional(),
  button_liquid_variables: z.array(z.string().nullable()).optional(),
  header_media_uri: z.string().nullable().optional(),
  header_asset_id: common.objectId.nullable().optional(),
  header_media_type: whatsAppMediaTypeSchema.nullable().optional(),
});
